import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
function FadeInUp({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 40
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.7,
    delay
  }} data-id="element-221">
      {children}
    </motion.div>;
}
export function OfferSection() {
  return <section id="offer" className="w-full py-24 px-4 relative overflow-hidden" style={{
    background: 'radial-gradient(ellipse at 50% 0%, #132040 0%, #0a1628 60%)'
  }} data-id="element-222">
      {/* Decorative top border */}
      <div className="absolute top-0 left-0 right-0 h-px" style={{
      background: 'linear-gradient(90deg, transparent, var(--color-gold), transparent)'
    }} data-id="element-223" />

      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-96 rounded-full blur-3xl opacity-10 pointer-events-none" style={{
      background: 'var(--color-gold)'
    }} data-id="element-224" />

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-225">
        <FadeInUp data-id="element-226">
          <div className="text-center mb-10" data-id="element-227">
            <div className="section-divider mb-6" data-id="element-228">
              <span className="ornament" data-id="element-229">✦</span>
            </div>
            <h2 className="font-heading font-700 text-4xl md:text-5xl mb-4" style={{
            color: 'var(--color-cream)'
          }} data-id="element-230">
              Tu Restauración Comienza
              <span className="block italic" style={{
              color: 'var(--color-gold)'
            }} data-id="element-231">
                Hoy
              </span>
            </h2>
            <p className="font-body text-lg leading-relaxed" style={{
            color: 'var(--color-cream-dim)'
          }} data-id="element-232">
              Queremos que esta sabiduría llegue a cada rincón donde se necesite
              restauración profunda.
            </p>
          </div>
        </FadeInUp>

        <FadeInUp delay={0.15} data-id="element-233">
          <div className="rounded-2xl p-8 md:p-10 relative overflow-hidden" style={{
          background: 'linear-gradient(135deg, rgba(201, 168, 76, 0.08) 0%, rgba(15, 31, 61, 0.95) 50%, rgba(74, 158, 255, 0.05) 100%)',
          border: '1px solid rgba(201, 168, 76, 0.4)',
          boxShadow: '0 0 60px rgba(201, 168, 76, 0.1), 0 20px 60px rgba(0,0,0,0.5)'
        }} data-id="element-234">
            {/* Corner ornaments */}
            <div className="absolute top-4 left-4 text-gold-dim opacity-30 font-heading text-2xl" style={{
            color: 'var(--color-gold-dim)'
          }} data-id="element-235">
              ✦
            </div>
            <div className="absolute top-4 right-4 text-gold-dim opacity-30 font-heading text-2xl" style={{
            color: 'var(--color-gold-dim)'
          }} data-id="element-236">
              ✦
            </div>
            <div className="absolute bottom-4 left-4 text-gold-dim opacity-30 font-heading text-2xl" style={{
            color: 'var(--color-gold-dim)'
          }} data-id="element-237">
              ✦
            </div>
            <div className="absolute bottom-4 right-4 text-gold-dim opacity-30 font-heading text-2xl" style={{
            color: 'var(--color-gold-dim)'
          }} data-id="element-238">
              ✦
            </div>

            {/* What's included */}
            <div className="mb-8" data-id="element-239">
              <h3 className="font-heading font-600 text-xl mb-5 text-center" style={{
              color: 'var(--color-cream-dim)'
            }} data-id="element-240">
                Incluye Todo el Sistema:
              </h3>
              <div className="space-y-3" data-id="element-241">
                <div className="flex items-center gap-3" data-id="element-242">
                  <span style={{
                  color: 'var(--color-olive)'
                }} data-id="element-243">
                    ✓
                  </span>
                  <span className="font-body text-base" style={{
                  color: 'var(--color-cream-dim)'
                }} data-id="element-244">
                    El Manual Maestro (100 páginas)
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-245">
                  <span style={{
                  color: 'var(--color-olive)'
                }} data-id="element-246">
                    ✓
                  </span>
                  <span className="font-body text-base" style={{
                  color: 'var(--color-cream-dim)'
                }} data-id="element-247">
                    Protocolo de 21 Días completo
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-248">
                  <span style={{
                  color: 'var(--color-olive)'
                }} data-id="element-249">
                    ✓
                  </span>
                  <span className="font-body text-base" style={{
                  color: 'var(--color-cream-dim)'
                }} data-id="element-250">
                    Guía de los 7 Superalimentos
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-251">
                  <span style={{
                  color: 'var(--color-olive)'
                }} data-id="element-252">
                    ✓
                  </span>
                  <span className="font-body text-base" style={{
                  color: 'var(--color-cream-dim)'
                }} data-id="element-253">
                    Rutina "Templo de Piedra"
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-254">
                  <span style={{
                  color: 'var(--color-olive)'
                }} data-id="element-255">
                    ✓
                  </span>
                  <span className="font-body text-base" style={{
                  color: 'var(--color-cream-dim)'
                }} data-id="element-256">
                    Lista de Compras Génesis
                  </span>
                </div>
              </div>
            </div>

            {/* Divider */}
            <div className="h-px mb-8" style={{
            background: 'linear-gradient(90deg, transparent, rgba(201, 168, 76, 0.3), transparent)'
          }} data-id="element-257" />

            {/* Price */}
            <div id="price-block" className="text-center mb-8" data-id="element-258">
              <p className="font-body text-sm tracking-widest uppercase mb-2" style={{
              color: 'var(--color-cream-muted)'
            }} data-id="element-259">
                Inversión única hoy
              </p>
              <div className="flex items-baseline justify-center gap-3 mb-2" data-id="element-260">
                <span className="font-heading font-700 text-7xl leading-none shimmer-text" data-id="element-261">
                  $6.39
                </span>
                <span className="font-body text-xl" style={{
                color: 'var(--color-cream-dim)'
              }} data-id="element-262">
                  USD
                </span>
              </div>
              <p className="font-body text-sm" style={{
              color: 'var(--color-cream-muted)'
            }} data-id="element-263">
                Una fracción del costo de una consulta privada
              </p>
            </div>

            {/* CTA Button */}
            <motion.button onClick={() => {
            if (window.fbq) {
              window.fbq('track', 'AddToCart', {
                content_name: 'El Código de la Longevidad Bíblica',
                content_type: 'product',
                value: 6.39,
                currency: 'USD'
              });
            }
            window.open('https://www.contenidodigitalpro.com/cart/47030470738069:1', '_blank');
          }} whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} className="cta-button w-full py-5 px-8 rounded-xl font-body font-700 text-xl uppercase tracking-wider" style={{
            background: 'linear-gradient(135deg, #C9A84C 0%, #E8C96A 50%, #C9A84C 100%)',
            color: '#0a1628',
            backgroundSize: '200% auto'
          }} data-id="element-264">
              ✦ Sí, Quiero Restaurar Mi Vitalidad Ahora ✦
            </motion.button>

            {/* Trust signals */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-6" data-id="element-265">
              <div className="flex items-center gap-2" data-id="element-266">
                <span className="text-lg" data-id="element-267">🔒</span>
                <span className="font-body text-sm" style={{
                color: 'var(--color-cream-muted)'
              }} data-id="element-268">
                  Transacción 100% segura
                </span>
              </div>
              <div className="hidden sm:block w-px h-4" style={{
              background: 'rgba(201, 168, 76, 0.2)'
            }} data-id="element-269" />
              <div className="flex items-center gap-2" data-id="element-270">
                <span className="text-lg" data-id="element-271">⚡</span>
                <span className="font-body text-sm" style={{
                color: 'var(--color-cream-muted)'
              }} data-id="element-272">
                  Acceso inmediato tras el pago
                </span>
              </div>
              <div className="hidden sm:block w-px h-4" style={{
              background: 'rgba(201, 168, 76, 0.2)'
            }} data-id="element-273" />
              <div className="flex items-center gap-2" data-id="element-274">
                <span className="text-lg" data-id="element-275">🛡️</span>
                <span className="font-body text-sm" style={{
                color: 'var(--color-cream-muted)'
              }} data-id="element-276">
                  100% privado
                </span>
              </div>
            </div>
          </div>
        </FadeInUp>

        {/* Final message */}
        <FadeInUp delay={0.3} data-id="element-277">
          <div className="text-center mt-12" data-id="element-278">
            <p className="font-heading text-xl italic font-400 leading-relaxed" style={{
            color: 'var(--color-cream-dim)'
          }} data-id="element-279">
              "No fuiste diseñado para pasar tus mejores años dependiendo de una
              bandeja de pastillas o temiendo perder tu autonomía."
            </p>
            <div className="gold-divider mt-6" data-id="element-280" />
          </div>
        </FadeInUp>
      </div>

      {/* Bottom border */}
      <div className="absolute bottom-0 left-0 right-0 h-px" style={{
      background: 'linear-gradient(90deg, transparent, var(--color-gold-dim), transparent)'
    }} data-id="element-281" />
    </section>;
}